module.exports = "select:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 #000;\n}\n"